import Icon from '../components/Icon.vue'

Icon.register({
  paperclip: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M43.2 466.1c-58.4-60.3-57.3-157.5 1.4-217.6l209.8-214.6c44.3-45.3 116.4-45.3 160.7 0 43.9 44.9 43.9 117.3 0 162.3l-182.8 186.9c-29.9 30.5-78.6 30.1-108-1-28.3-30-27.4-77.5 1.5-107l143.7-146.8c6.2-6.3 16.3-6.4 22.6-0.2l22.9 22.4c6.3 6.2 6.4 16.3 0.2 22.6l-143.7 146.8c-4.9 5-5.2 13.4-0.6 18.3 4.4 4.6 11.2 4.7 15.7 0.2l182.8-186.9c19.6-20.1 19.6-52.7 0-72.8-19.2-19.6-50-19.6-69.2 0l-209.8 214.6c-34.8 35.6-35.3 93.1-1.2 128.3 34 35.1 89 35.1 123.1 0.3l172.1-176c6.2-6.3 16.3-6.4 22.6-0.3l22.9 22.4c6.3 6.2 6.4 16.3 0.3 22.6l-172.1 176c-59.6 60.9-155.9 60.2-214.8-0.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/paperclip.js
// module id = 1607
// module chunks = 0